import { formatDate } from '@/helpers/dates';

import { RmpcNestedDictionaryType, RmpcTattooDetailed } from '@/api/integrations/rmpc/types/types';

import { getTypeValuesFromDictionary, getBodyPartValuesFromDictionary } from '../../../utils/getTattooDictionaryValues';

const formatUniqueValues = (values: string[]): string | null => {
  const uniqueValues = Array.from(new Set(values));
  return uniqueValues.length > 0 ? uniqueValues.join(', ') : null;
};

export const buildGridData = (
  tattooData: RmpcTattooDetailed,
  categories: RmpcNestedDictionaryType[],
  bodyLocations: RmpcNestedDictionaryType[],
): Array<[string, Nullable<string>]> => {
  const typeData =
    tattooData.types && categories.length > 0
      ? getTypeValuesFromDictionary(categories, tattooData.types)
      : { category: [], type: [] };

  const categoryDisplay = formatUniqueValues(typeData.category);
  const typeDisplay = formatUniqueValues(typeData.type);

  const bodyPartData =
    tattooData.body_parts && bodyLocations.length > 0
      ? getBodyPartValuesFromDictionary(bodyLocations, tattooData.body_parts)
      : { body_location: [], body_type: [] };

  const bodyLocationDisplay = formatUniqueValues(bodyPartData.body_location);
  const bodyTypeDisplay = formatUniqueValues(bodyPartData.body_type);

  return [
    ['Номер ескізу', tattooData.number],
    ['Категорія тату', categoryDisplay],
    ['Тип тату', typeDisplay],
    ['Місце розташування', bodyLocationDisplay],
    ['Частина тіла', bodyTypeDisplay],
    ['Дата додавання ескіза', formatDate(tattooData.published_at)],
    ['Опис', tattooData.description || null],
  ];
};
